import { useState } from "react";
// import {
//   blogimg2
// } from "../imagepath";
import { Link } from "react-router-dom";
import DataTable from "../DataTables/DataTable";
import DoctorListHero from "../heros/DoctorListHero";
import { useDoctorsList } from "../../hooks/doctors/useDoctorsList";
import CircularImage from "../assests/CircularImage";
import { user_profile } from "../imagepath";
import StatusBadge from "../assests/StatusBadge";
import { formatDateDDMMYY } from "../configs/fomatDateDDMMYY";
// import { blogimg12 } from "../imagepath";
import { Tag } from "antd";
import ToggleModal from "../Hospitals/ToggleModal";
import { useChangeDoctorStatus } from "../../hooks/doctors/useChangeDoctorStatus";
function DoctorsList() {
  const [show, setShow] = useState(false);

  const [searchTerm, setSearchterm] = useState("");
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [status, setStatus] = useState("");
  const [disable, setdisable] = useState(false);
  const { mutate, isLoading: statusChangeLoading } = useChangeDoctorStatus();
  const query = searchTerm ? `name=${searchTerm}` : "";
  const { data: doctorList, isLoading } = useDoctorsList(query);
  console.log("Doctor list ", doctorList);

  const handelSearchTerm = (term) => {
    setSearchterm(term);
  };

  const handleTogglebtn = (id, status) => {
    setSelectedDoctor(id);
    setShow(true);
    setStatus(status);
  };

  const handleDisable = async () => {
    const data = {
      status: status === "active" ? "disabled" : "active",
    };
    await mutate({ id: selectedDoctor, data: data },{
      onSuccess:()=>{
        setShow(false);
      },
      onError:()=>{
        setShow(false);
      }
    });
  };

  const columns = [
    {
      title: "NAME",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (text, record) => (
        <Link to={`/manage-doctors/${record.id}`}>
          <div className="d-flex">
            <div>
              <CircularImage
                src={record?.profile_pic ?? user_profile}
                alt={record.name}
                size={40}
                fallback={user_profile}
              />
            </div>
            <div className="ms-2 table-profile">
              <h6>{record.name}</h6>
              <p className="text-muted mb-0">{record.email}</p>
            </div>
          </div>
        </Link>
      ),
      // sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "SPECIALISATION",
      dataIndex: "specialisations",
      // sorter: (a, b) => a.Specialization.length - b.Specialization.length,
      render: (specialisations) => (
        <div className="d-flex flex-wrap gap-2" style={{ maxWidth: "200px" }}>
          {specialisations?.map((specialisation) => (
            <Tag key={specialisation.id} color="cyan">
              {specialisation.name}
            </Tag>
          ))}
        </div>
      ),
    },
    {
      title: "MOBILE",
      dataIndex: "phone_number",
      render: (text) => (
        <>
          <Link to="#">{text}</Link>
        </>
      ),
    },
    {
      title: "STATUS",
      dataIndex: "status",
      filters: [
        { text: "active", value: "active" },
        { text: "inactive", value: "inactive" },
        { text: "pending", value: "pending" },
        { text: "rejected", value: "rejected" },
        { text: "disabled", value: "disabled" },
      ],
      onFilter: (value, record) => record.status === value,
      filterSearch: true,

      render: (item) => (
        <div>
          <StatusBadge status={item} />
        </div>
      ),
    },
    {
      title: <div className="text-center">JOINING DATE</div>,
      dataIndex: "work_start_date",
      sorter: (a, b) =>
        new Date(a.work_start_date) - new Date(b.work_start_date),
      render: (item) => (
        <div className="d-flex justify-content-center">
          {item ? formatDateDDMMYY(item) : "N/A"}
        </div>
      ),
      // sorter: (a, b) => a.JoiningDate.length - b.JoiningDate.length,
    },
    {
      title: "",
      dataIndex: "FIELD8",
      render: (item, record) => (
        <>
          <div className="text-end">
            <div className="dropdown dropdown-action">
              <Link
                to="#"
                className="action-icon dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-ellipsis-v" />
              </Link>
              <div className="dropdown-menu dropdown-menu-end">
                <Link
                  className="dropdown-item"
                  to={`/manage-doctors/${record.id}`}
                >
                  <i className="far fa-eye me-2" />
                  View
                </Link>
                <Link
                  className="dropdown-item"
                  to={`/manage-doctors/${record.id}/edit`}
                  aria-disabled="true"
                >
                  <i className="far fa-edit me-2" />
                  Edit
                </Link>

                <Link
                  className="dropdown-item"
                  to="#"
                  onClick={() => handleTogglebtn(record.id, record.status)}
                >
                  <div
                    // onClick={handleTogglebtn}
                    className="status-toggle d-flex align-items-center"
                  >
                    <input
                      type="checkbox"
                      id="status"
                      className="check"
                      checked={record?.status === "active" ? true : false}
                    />
                    <label htmlFor="status" className="checktoggle-small">
                      checkbox
                    </label>
                    <span className="ps-2">
                      {record?.status === "active" ? "Disable" : "Enable"}
                    </span>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </>
      ),
    },
  ];

  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="card card-table show-entire">
          <div className="card-body">
            {/* Table Header */}
            <DoctorListHero handelSearchTerm={handelSearchTerm} />
            <div className="doctor-list">
              <DataTable
                data={doctorList ?? []}
                columns={columns}
                isLoading={isLoading}
              />
            </div>
          </div>
        </div>
      </div>
      <ToggleModal
        show={show}
        setShow={setShow}
        setdisable={setdisable}
        disable={disable}
        title="Doctor"
        handleDisable={handleDisable}
        isLoading={statusChangeLoading}
      />
    </div>
  );
}

export default DoctorsList;
